export const OtherIcon = ({ width, height }: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "15"}
    height={height || "16"}
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M10.8597 7.98001L5.18969 14.16C5.06969 14.29 4.90969 14.36 4.73969 14.36C4.58969 14.36 4.44969 14.31 4.32969 14.2C4.07969 13.97 4.06969 13.59 4.28969 13.35L8.99969 8.22001H0.789687C0.459687 8.22001 0.179688 7.95001 0.179688 7.61001C0.179688 7.27001 0.449687 7.01001 0.789687 7.01001H9.05969L4.23969 1.72001C4.01969 1.47001 4.02969 1.09001 4.27969 0.870006C4.52969 0.650006 4.90969 0.660006 5.12969 0.910006L10.8397 7.18001C11.0497 7.41001 11.0497 7.76001 10.8397 8.00001L10.8597 7.98001Z"
      fill="#BAFD4F"
    />
    <path
      d="M7.89143 15.03C7.73143 15.03 7.57143 14.97 7.44143 14.86C7.17143 14.61 7.15143 14.19 7.40143 13.92L13.2214 7.58L7.35143 1.14C7.10143 0.870002 7.12143 0.450002 7.39143 0.200002C7.66143 -0.0499984 8.08143 -0.0299984 8.33143 0.240002L14.6114 7.13C14.8414 7.38 14.8414 7.77 14.6114 8.03L8.38143 14.82C8.25143 14.96 8.07143 15.04 7.89143 15.04V15.03Z"
      fill="#BAFD4F"
    />
  </svg>
)
